import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import {NoSsr} from "@mui/material";
import MainLayout from "../../components/layout/MainLayout";
import PercelDelivery from "../../components/parcel/parcel-delivery-info-component/ParcelDelivary";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = ({configData}) => {
    return (<>
            <CssBaseline/>
            <SEO
                title={configData ? `Parcel Deliver information` : "Loading..."}
                image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
                businessName={configData?.business_name}
            />
            <MainLayout configData={configData}>
                <NoSsr>
                    <PercelDelivery configData={configData}/>
                </NoSsr>
            </MainLayout>
        </>);
};

export default Index;
